/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarket,
    BrandAndMarketFromJSON,
    BrandAndMarketFromJSONTyped,
    BrandAndMarketToJSON,
    FieldPermission,
    FieldPermissionFromJSON,
    FieldPermissionFromJSONTyped,
    FieldPermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface PermissionListItem
 */
export interface PermissionListItem {
    /**
     * 
     * @type {BrandAndMarket}
     * @memberof PermissionListItem
     */
    brandAndMarket?: BrandAndMarket;
    /**
     * 
     * @type {FieldPermission}
     * @memberof PermissionListItem
     */
    restriction?: FieldPermission;
}

export function PermissionListItemFromJSON(json: any): PermissionListItem {
    return PermissionListItemFromJSONTyped(json, false);
}

export function PermissionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketFromJSON(json['brandAndMarket']),
        'restriction': !exists(json, 'restriction') ? undefined : FieldPermissionFromJSON(json['restriction']),
    };
}

export function PermissionListItemToJSON(value?: PermissionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketToJSON(value.brandAndMarket),
        'restriction': FieldPermissionToJSON(value.restriction),
    };
}


